import type { StimHomePrescription } from '@MP/shared/api/hooks/stimHome';
import { StimHomePrescriptionStatus } from '@MP/shared/api/hooks/stimHome';

const PrescriptionUtils = {
  hasInProgress: (prescriptions: StimHomePrescription[] = []) => {
    return prescriptions.some((v) => {
      const status = v.status;
      return status === StimHomePrescriptionStatus.InProgress || status === StimHomePrescriptionStatus.Waiting;
    });
  },
  isInprogress: (prescriptions: StimHomePrescription) => {
    return (
      prescriptions.status === StimHomePrescriptionStatus.InProgress ||
      prescriptions.status === StimHomePrescriptionStatus.Waiting
    );
  },
  // 배송 요청 전(입력 대기) 상태. 병원 계정이 취소할 수 있는 유일한 상태.
  isInputWaiting: (prescription: StimHomePrescription) => {
    return prescription.status === StimHomePrescriptionStatus.Waiting && !prescription.deliveryRequestedAt;
  },
};

export default PrescriptionUtils;
